import Cookies from 'js-cookie';
import AbstractStorage from './AbstractStorage';

class CookieStorage extends AbstractStorage {
  static get<T>(key: string): T | null {
    const data = Cookies.get(key);
    if (data) return JSON.parse(data);
    return null;
  }

  static set<T>(key: string, value: T): void {
    if (value) {
      Cookies.set(key, JSON.stringify(value));
    }
  }

  static remove(key: string): void {
    Cookies.remove(key);
  }

  static clear(): void {
    const allCookies = Cookies.get();
    for (const key in Object.keys(allCookies)) {
      Cookies.remove(key);
    }
  }
}

export default CookieStorage;
